import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import IconLeftArrow from "src/assets/images/icon_left_arrow.svg";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import moment from "moment";
import _ from "lodash";
import { getAllDepotPerson, unlistDepot, getByIdDepot, editDepot, getAllDepots } from "src/thunks/depotUsers";
import IconEditRecord from "src/assets/images/icon_editrecord.svg";
import IconRemove from "src/assets/images/icon_remove.svg";
import IconManagerAllocate from "src/assets/images/icon_managerallocate.svg";
import { Loader } from "src/components/loader";
import toastMessages from "src/constant/toastMessages.json";
import { GetError, getFloatValue } from "src/constant";
import { CommonModal } from "src/components/modal";
import { AddNewDepot } from "./component/addNewDepot";
import { DepotTableDataPage } from "./component/depotTableDataPage";
import { AllocationManager } from "./component/allocationManager";
import { RemoveDepotManager } from "./component/removeDepoManager";
import { UnlistDepot } from "./component/unlistDepot";
import { getAllNofificationForDashboard } from "src/thunks/dashboard";


export const Depots = () => {
    /** redux store useDispatch & useSelector ------------------------------ **/
    const dispatch = useDispatch();
    const { depoData, getAllDepotsLoading } = useSelector((state) => state.depotUsers);
    const { signoutModelOpenFlag } = useSelector((state) => state.auth);

    /** hooks useState ----------------------------------------------------- **/
    const [indData, setIndData] = useState({})
    const [loader, setloader] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});
    const [selectedDepotManagersRow, setSelectedDepotManagersRow] = useState("");
    const [isEditFlag, setIsEditFlag] = useState(false);
    const [editTextShownFlag, setEditTextShownFlag] = useState(false);
    const [showViewRecordButton, setShowViewRecordButton] = useState(false);
    const [IsActive, setIsActive] = useState(false);
    const [open, setOpen] = useState(false);
    const [allocateManagerModal, setAllocateManagerModal] = useState(false);
    const [isClickOnIndividualDepotManagers, setIsClickOnIndividualDepotManagers] = useState(false);
    const [isRemoveManagerButtonClick, setIsRemoveManagerButtonClick] = useState(false);
    const [isUnlistDepotFlag, setIsUnlistDepotFlag] = useState(false);
    const [allDepotPersonnelUsers, setAllDepotPersonnelusers] = useState([]);
    const [showAllAllocateManagerUsers, setShowAllAllocateManagersUsers] = useState([]);

    /** handler functions--------------------------------------------------- **/

    /** Function to handle image errors --------------------- **/
    const imgError = (image) => {
        image.onerror = "";
        image.src = "https://img.freepik.com/free-icon/user_318-563642.jpg";
        return true;
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const handleAllocateManagerClose = () => {
        setAllocateManagerModal(false);
        setShowAllAllocateManagersUsers([]);
    };
    const handleRemoveManagerClose = () => setIsRemoveManagerButtonClick(false);

    const handleGoBackClick = () => setIsRemoveManagerButtonClick(false);

    const handleUnlistDepotClick = () => setIsUnlistDepotFlag(true);

    const handleUnlistDepotModalClose = () => setIsUnlistDepotFlag(false);

    const handleCancelButtonClick = () => {
        setOpen(false);
        setEditTextShownFlag(false);
    };

    /** Function to navigate back -------------------------- **/
    const handleBackButtonClick = async () => {
        setIsEditFlag(false);
        setSelectedRow({});
        setEditTextShownFlag(false);
        setSelectedDepotManagersRow({});
        setIndData({})
        await dispatch(getAllDepots());
    };

    /** Function to handle individual row clicks ----------------- **/
    const handleRowClick = (item) => {
        setSelectedRow(item);
        setShowViewRecordButton(!showViewRecordButton);
    };

    /** Function to handle the click event of the 'View Record' button and retrieve the result of individual depot by Id ---------------------- **/
    const handleViewRecordButtonClick = async () => {
        setIsEditFlag(true);
        setloader(true);
        try {
            let res = await dispatch(getByIdDepot(selectedRow.id));
            if (res) {
                setIndData(res.payload)
            }
            setloader(false);
        } catch (err) {
            toast.error(GetError(err?.response?.data?.errors) || "something issue");

        }
    };

    /** Function to retrieve all depot managers who are allocated to any of the depots ------------------- **/
    const getAllData = (data) => {
        const getOnlyDepotManagerUsers = _.filter(data || [], (d) => {
            let filteredAllocatedDepots = _.filter(d?.depots || [], (d1) => d1.hasAllocated == true);
            const containsId = filteredAllocatedDepots.some(item => item.id === selectedRow?.id);
            if (!containsId && !(d?.roles == "Admin")) {
                return d
            }
        }) || []
        return getOnlyDepotManagerUsers;
    };

    /** Function to retrieve all depot managers and save them into the state ---------------------------- **/
    const handleAllocateManagerClick = async () => {
        setAllocateManagerModal(true);
        setloader(true);
        try {
            let res = await dispatch(getAllDepotPerson());
            if (res) {
                setAllDepotPersonnelusers(res.payload);
                setloader(false);
                let allData = getAllData(res.payload);
                setShowAllAllocateManagersUsers([...allData]);
            }
        } catch (err) {
            toast.error(GetError(err?.response?.data?.errors) || "something issue");
        }
    };

    /** Function to remove the allocated manager from the depot ----------------------- **/
    const handleRemoveAllocatedDepotManager = async () => {
        try {
            let removedDataModel = {
                name: indData?.name || "",
                code: indData?.code || "",
                address: {
                    street1: indData?.address?.street1 || "",
                    city: indData?.address?.city || "",
                    country: indData?.address?.country || "",
                    zip: indData?.address?.zip || "",
                    state: "mh"
                },
                internalArea: indData?.internalArea || 0,
                externalArea: indData?.externalArea || 0,
            };
            let filteredDepotUsersArray = _.filter(indData.depotUsers, (d) => d.userId != selectedDepotManagersRow.userId);
            const updatedDepotUsersArray = filteredDepotUsersArray.map((item, index) => {
                return { userId: item.userId };
            });
            let result = await dispatch(editDepot({
                data: {
                    ...removedDataModel, id: selectedRow.id,
                    depotUsers: updatedDepotUsersArray ? updatedDepotUsersArray : [],
                    "isParentResourceUpdated": false,
                    "removeAllocationActivity": true,
                    "NewDeallocationUsers": _.find(indData.depotUsers, (d) => d.userId === selectedDepotManagersRow.userId)
                }
            })).unwrap();
            if (result) {
                setTimeout(() => {
                    dispatch(getAllNofificationForDashboard(1, 20));
                }, 2000);
                handleViewRecordButtonClick();
                toast.success(toastMessages.depotMgnrRemoved);
                setIsRemoveManagerButtonClick();
            }
        } catch (err) {
            toast.error(GetError(err?.response?.data?.errors) || "something issue");
        }
    };

    /** Function executes when the user clicks on 'Edit Depot' -------------------- **/
    const handleEditDepotClick = async () => {
        setEditTextShownFlag(true);
        setOpen(true);
    };

    /** Function is used when a single row is selected from the table and respective data saved to the state. ------------------------- **/
    const handleSingleRowManagerClick = (item) => {
        setSelectedDepotManagersRow(item);
        setIsClickOnIndividualDepotManagers(!isClickOnIndividualDepotManagers);
    };

    /** Function to unlist a depot. -------------------------- **/ 
    const unlistDepotClickHandler = async () => {
        try {
            await dispatch(unlistDepot({ id: selectedRow.id, data: selectedRow })).unwrap();
            setTimeout(() => {
                dispatch(getAllNofificationForDashboard(1, 20));
            }, 2000);
            await dispatch(getAllDepots())
            toast.success(toastMessages.depotUnlisted);
            handleUnlistDepotModalClose();
            setIsEditFlag(false);
            handleBackButtonClick({})
        } catch (err) {
            toast.error(GetError(err?.response?.data?.errors) || "something issue");
        }
    };
 
    const handleRemoveManagerClick = () => {
        setIsRemoveManagerButtonClick(true);
    };

    /** Function to change the selected flag value when the user clicks on the checkbox. -------------------- **/
    const HandleAllocatedChecked = (id) => {
        let Data = _.map(showAllAllocateManagerUsers, (d) => {
            let temp = { ...d };
            if (d.id === id) {
                if (!temp.selected) {
                    temp.selected = true;
                } else {
                    temp.selected = false;
                }
            }
            return temp;
        });
        setShowAllAllocateManagersUsers([...Data]);
    };

    /** function to handle the submit call from the allocate manager modal. ------------------- **/
    const handleSubmitButtonOfAllocatedManager = async () => {
        try {
            let updatedModel = {
                name: indData?.name || "",
                code: indData?.code || "",
                address: {
                    street1: indData?.address?.street1 || "",
                    city: indData?.address?.city || "",
                    country: indData?.address?.country || "",
                    zip: indData?.address?.zip || "",
                    state: "",
                },
                internalArea: indData?.internalArea || 0,
                externalArea: indData?.externalArea || 0,
            };
            const oldDepotUsers = indData?.depotUsers?.map(
                (item, index) => {
                    return {
                        userId: item.userId,
                    };
                }
            );
            let filteredDepotUsersArray = _.filter(showAllAllocateManagerUsers, (d) => d.selected == true);
            const updatedDepotUsersArray = filteredDepotUsersArray.map(
                (item, index) => {
                    return {
                        userId: item.id,
                    };
                }
            );
            const concatenatedArray = [...oldDepotUsers, ...updatedDepotUsersArray];
            let result = await dispatch(
                editDepot({
                    data: {
                        ...updatedModel,
                        id: selectedRow.id,
                        depotUsers: concatenatedArray ? concatenatedArray : [],
                        "isParentResourceUpdated": false,
                        "allocateManager": true,
                        "NewAllocationManager": filteredDepotUsersArray
                    },
                })
            ).unwrap();
            if (result) {
                setTimeout(() => {
                    dispatch(getAllNofificationForDashboard(1, 20));
                }, 2000);
                handleViewRecordButtonClick();
                toast.success(toastMessages.depotMgnrAllocated);
                setAllocateManagerModal(false);
                setIsActive(null);
                setTimeout(() => {
                    setShowAllAllocateManagersUsers([]);
                }, 3000);
            }
        } catch (err) {
            toast.error(GetError(err?.response?.data?.errors) || "something issue");
        }
    };

    /** Function to retrieve all allocated depot names. ------------------ **/
    const showAllocatedDepotName = (data) => {
        let filteredArray = _.filter(data?.depots || [], (d) => d.hasAllocated)
        if (data?.depots?.length > 0 && filteredArray.length > 0) {
            return filteredArray?.map(item => item.name).join(' , ')
        } else {
            return "Inactive"
        }

    };

    /** Function to retrieve the allocated date for the depot. ---------------------- **/
    const showAllocatedDate = (data) => {
        var allocatedDate = _.find(data?.depots || [], (d) => d.hasAllocated)?.allocatedOn || null;
        return allocatedDate ? moment(allocatedDate).format("DD-MMM-YYYY") : moment(data?.raisedOn).format('DD-MMM-YYYY');
    };

    if (loader || getAllDepotsLoading) {
        return <Loader />
    }

    return (
        <>
            {!isEditFlag ? (
                <DepotTableDataPage
                    depoData={depoData}
                    handleRowClick={handleRowClick}
                    selectedRow={selectedRow}
                    showViewRecordButton={showViewRecordButton}
                    handleViewRecordButtonClick={handleViewRecordButtonClick}
                    handleOpen={handleOpen}
                />
            ) : (
                <>
                    <div
                        className={`main-details-div-for-goodsin ${signoutModelOpenFlag == true
                            ? "add-overlay-for-depot-dropdown"
                            : ""
                            }`}
                    >
                        <div className="row">
                            <div
                                className="d-flex justify-content-center first-row-details-goodsin-page"
                                onClick={() => handleBackButtonClick()}
                            >
                                <div className="d-flex justify-content-center align-items-center goodsin-back-icon-size">
                                    <img src={IconLeftArrow} alt="left arrow" />
                                </div>
                            </div>

                            <div className="admin-details-subdiv-style">
                                <div className="edit-depotheader align-items-center d-flex flex-row justify-content-between">
                                    <div className="depotname-section">
                                        {indData?.name || ""}{" "}
                                        {`[${indData?.code}]`}
                                    </div>

                                    <div className="me-3">
                                        <span className="me-2 address-main-header-text">
                                            ACTIVE SINCE
                                        </span>
                                        <span className="address-subsection text-uppercase">
                                            {moment(indData?.createdOn).format(
                                                "DD-MMM-YYYY"
                                            )}
                                        </span>
                                    </div>
                                </div>

                                <div className="d-flex flex-column add-space-margin-top-space">
                                    <span className="address-main-header-text">ADDRESS</span>
                                    <div className="address-subsection">
                                        {indData?.address?.street1 || ""}{" "}
                                        {indData?.address?.street2 || ""}{" "}
                                        {indData?.address?.state},{" "}
                                        {indData?.address?.city} ,
                                        {indData?.address?.country} ,
                                        {indData?.address?.zip}
                                    </div>
                                </div>

                                <div className="d-flex flex-row  add-space-margin-top-space">
                                    <div className="d-flex flex-column col-md-4">
                                        <span className="address-main-header-text">
                                            INTERNAL SPACE (m<sup>2</sup>)
                                        </span>
                                        <span className="address-subsection">
                                            {indData?.internalArea || ''}
                                        </span>
                                    </div>
                                    <div className="d-flex flex-column col-md-4">
                                        <span className="address-main-header-text">
                                            EXTERNAL SPACE (m<sup>2</sup>)
                                        </span>
                                        <span className="address-subsection">
                                            {indData?.externalArea || ''}
                                        </span>
                                    </div>{" "}
                                    <div className="d-flex flex-column col-md-4">
                                        <span className="address-main-header-text">
                                            TOTAL SPACE (m<sup>2</sup>)
                                        </span>
                                        <span className="address-subsection">
                                            {getFloatValue((indData?.internalArea || 0) + (indData?.externalArea || 0))}
                                        </span>
                                    </div>
                                </div>

                                <div className="d-flex flex-row justify-content-between">
                                    <div className="address-main-header-text">
                                        DEPOT MANAGERS (
                                        {indData?.depotUsers?.length || 0})
                                    </div>

                                    <div className="me-3 address-main-header-text">
                                        ALLOCATED ON
                                    </div>
                                </div>

                                <div className="">
                                    <div className="table-responsive depotmanagers-table">
                                        <table className="table table-borderless">
                                            <thead className="visually-hidden">
                                                <tr>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Contact Number</th>
                                                    <th scope="col">Email</th>
                                                    <th scope="col">Active since</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {indData?.depotUsers &&
                                                    indData?.depotUsers[0] &&
                                                    indData?.depotUsers
                                                        .filter((d) => d.hasAllocated == true)
                                                        .map((item, index) => {
                                                            return (
                                                                <React.Fragment key={index}>
                                                                    <tr
                                                                        className={`depots-tabdetails--body-style ${selectedDepotManagersRow.id == item.id
                                                                            ? "row-border"
                                                                            : ""
                                                                            }`}
                                                                        onClick={() => handleSingleRowManagerClick(item)}
                                                                    >
                                                                        <td>
                                                                            <img
                                                                                src={item?.profileUrl || "https://img.freepik.com/free-icon/user_318-563642.jpg"}
                                                                                onError={imgError}
                                                                                alt="img"
                                                                                width={25}
                                                                                height={25}
                                                                                className="me-1 depot-personel-list-img-style"
                                                                            />
                                                                            {item?.firstName || ""} {item?.lastName || ""}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {item?.phoneNumber || ""}
                                                                        </td>
                                                                        <td className="text-end">{item.email}</td>
                                                                        <td className="text-end">
                                                                            {moment(item?.allocatedOn).format("DD-MMM-YYYY") || ""}
                                                                        </td>
                                                                    </tr>
                                                                    {isClickOnIndividualDepotManagers &&
                                                                        selectedDepotManagersRow?.id == item?.id ? (
                                                                        <tr className={`view-record-button`}>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td className="text-end">
                                                                                <button
                                                                                    className=" mb-2 p-1 remove-depot-manager-button-style"
                                                                                    style={{
                                                                                        fontFamily: "Montserrat-Regular",
                                                                                        fontSize: 10,
                                                                                        cursor: "pointer",
                                                                                        color: "#E94F37",
                                                                                    }}
                                                                                    onClick={handleRemoveManagerClick}
                                                                                >
                                                                                    <RemoveCircleOutlineOutlinedIcon
                                                                                        style={{
                                                                                            color: "#E94F37",
                                                                                            cursor: "pointer",
                                                                                            fontSize: 15,
                                                                                        }}
                                                                                        className="remove-item-icon-color me-1"
                                                                                    />
                                                                                    REMOVE
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </React.Fragment>
                                                            );
                                                        })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div style={{ height: 60 }}>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex">
                                            <div className="me-4">
                                                <Button
                                                    variant="outlined"
                                                    style={{ color: "red", borderColor: "red" }}
                                                    startIcon={
                                                        <img
                                                            src={IconRemove}
                                                            width={15}
                                                            height={15}
                                                            alt="new"
                                                        ></img>
                                                    }
                                                    onClick={handleUnlistDepotClick}
                                                >
                                                    UNLIST DEPOT
                                                </Button>
                                            </div>

                                            <div>
                                                <Button
                                                    variant="outlined"
                                                    className="submit-btn-style"
                                                    startIcon={
                                                        <img
                                                            src={IconEditRecord}
                                                            width={17}
                                                            height={17}
                                                            alt="new"
                                                        ></img>
                                                    }
                                                    onClick={handleEditDepotClick}
                                                >
                                                    EDIT DEPOT
                                                </Button>
                                            </div>
                                        </div>
                                        <Button
                                            variant="outlined"
                                            className="submit-btn-style"
                                            startIcon={<img src={IconManagerAllocate} width={17} height={17} alt="new" ></img>}
                                            onClick={handleAllocateManagerClick}
                                        >
                                            ALLOCATE MANAGER
                                        </Button>
                                    </div>
                                </div>
                            </div>

                            <div className=" first-row-details-goodsin-page"></div>
                        </div>
                    </div>
                </>
            )}

            <CommonModal togal={open} toggleHandler={handleClose}>
                <AddNewDepot
                    indData={indData}
                    handleCancelButtonClick={handleCancelButtonClick}
                    setOpen={handleClose}
                    selectedRow={selectedRow}
                    handleViewRecordButtonClick={handleViewRecordButtonClick}
                    setEditTextShownFlag={setEditTextShownFlag}
                />
            </CommonModal>
            <CommonModal
                togal={allocateManagerModal}
                toggleHandler={handleAllocateManagerClose}
            >
                <AllocationManager
                    allDepotPersonnelUsers={allDepotPersonnelUsers}
                    selectedRow={selectedRow}
                    IsActive={IsActive}
                    showAllAllocateManagerUsers={showAllAllocateManagerUsers}
                    showAllocatedDepotName={showAllocatedDepotName}
                    setIsActive={setIsActive}
                    showAllocatedDate={showAllocatedDate}
                    HandleAllocatedChecked={HandleAllocatedChecked}
                    handleAllocateManagerClose={handleAllocateManagerClose}
                    handleSubmitButtonOfAllocatedManager={handleSubmitButtonOfAllocatedManager}
                    setShowAllAllocateManagersUsers={setShowAllAllocateManagersUsers}
                    getAllData={getAllData}

                />
            </CommonModal>

            <CommonModal
                togal={isRemoveManagerButtonClick}
                toggleHandler={handleRemoveManagerClose}
            >
                <RemoveDepotManager
                    selectedRow={selectedRow}
                    selectedDepotManagersRow={selectedDepotManagersRow}
                    handleGoBackClick={handleGoBackClick}
                    handleRemoveAllocatedDepotManager={handleRemoveAllocatedDepotManager}
                />
            </CommonModal>

            <CommonModal
                togal={isUnlistDepotFlag}
                toggleHandler={handleUnlistDepotModalClose}
            >
                <UnlistDepot
                    selectedRow={selectedRow}
                    handleUnlistDepotModalClose={handleUnlistDepotModalClose}
                    unlistDepotClickHandler={unlistDepotClickHandler}
                />
            </CommonModal>

        </>
    );
};

